export { default } from './BorrowingUtilityBarTitle';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingUtilityBarTitle/index.js